import { Component, ChangeDetectorRef, ChangeDetectionStrategy, Input } from "@angular/core";
import { PeopleInfoAddress } from "projects/sepidz-web-framework/src/lib/models/peopleInfo-address.model";
import { Lookup, City, form_control } from "projects/sepidz-web-framework/src/lib/models";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { FormControlTypes } from "projects/sepidz-web-framework/src/lib/models/form-base-control.model";

@Component({
  selector: "address-from",
  templateUrl: "./address-from.component.html",
  styleUrls: ["./address-from.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddressFromComponent extends BaseFormComponent<PeopleInfoAddress> {
  @Input() Columns: form_control[];
  constructor(protected selectorService: SelectorService, protected cd: ChangeDetectorRef) {
    super(selectorService, cd);
  }

  async ngOnInit() {
    this.noLoadData = true;
    super.ngOnInit();
    if (!this.apiName) this.apiName = "PeopleInfo";
    this.label = this.translate("ClientApp.GNR.PeopleInfo.Address.Address");
    this.setdefault();
  }
  setdefault() {
    this.isNewRow = !this.currentrow;
    Object.assign(this.model, this.currentrow);
    if (this.model.IsDefault === undefined) this.model.IsDefault = false;
    this.setFormGroup(this.model);
    if (!this.model.PeopleInfoId) this.model.PeopleInfoId = 0;
    if (this.currentrow && this.currentrow.Id) this.id = !this.id ? this.currentrow.Id : this.id;
    this.cd.markForCheck();
  }
  async setColumns() {
    Object.assign(this.orignalColumns, this.Columns);
    this.orignalColumns.forEach((x) => {
      if (!x.tabOrder) x.tabOrder = x.order ?? 0;
    });
    this.orignalColumns.forEach((x) => {
      if (x.modelName === "ZipCode") {
        x.patternKey = "^[1-9]\\d{9}";
      }
      if (x.name === "CityId" && x.controlType === FormControlTypes.treelookup) x.controlType = FormControlTypes.dropdown;
    });
    this.columns = this.orignalColumns.filter(
      (f) => ((!f.areaName || f.areaName === "default") && f.formVisible) || (f.DetailControlModels && f.DetailControlModels[f.name].length > 0)
    );
    this.columns = this.columns.sort((a, b) => a.order - b.order);
    this.setColumnNumber(this.columns);
  }

  public async save() {
    this.result = this.getDataFromFormGroup();
    this.close();
  }
  reMoveRepeated() {
    let temp = this.formGroup
      ?.get("Address")
      ?.value.replace(/^\s+|\s+$/g, "")
      .split(" ");
    let temp2: string = "";
    temp.forEach((x) => {
      if (temp.filter((s) => s === x).length <= 2) {
        if (x !== "") {
          if (temp2 === "") temp2 = x.replace(/^\s+|\s+$/g, "").replace(/(.)(?=.*\4)/g, "");
          else temp2 += " " + x.replace(/^\s+|\s+$/g, "").replace(/(.)(?=.*\4)/g, "");
        }
      }
    });
    if (temp.filter((x) => x === "").length >= 1 || this.formGroup?.get("Address")?.value[this.formGroup?.get("Address")?.value.length - 1] === " ")
      temp2 += " ";
    if (this.formGroup?.get("Address")?.value !== temp2) this.setValue("Address", temp2);
  }
  onChanged($event) {
    if ($event.SystemName) {
      this.model.AddressKindTitle = ($event as Lookup).Title;
      this.setValue("AddressKindTitle", this.model.AddressKindTitle);
    } else {
      if ($event.ProvinceId) {
        this.model.CityTitle = ($event as City).Title;
        this.setValue("CityTitle", this.model.CityTitle);
      } else {
        if ($event.Title && this.model.ProvinceTitle !== $event.Title) {
          this.model.CityId = undefined;
          this.model.CityTitle = undefined;
          this.setValue("CityId", undefined);
          this.setValue("CityTitle", undefined);
          this.selectorService.setParetnIdValue("ProvinceId", $event.Id);
        }
        if ($event.Title) {
          this.model.ProvinceTitle = $event.Title;
          this.setValue("ProvinceTitle", $event.Title);
        }
      }
    }
    this.reMoveRepeated();
  }
}
